import { onMounted, ref } from 'vue'

// Fix for SSR hydrating mismatch according to
// https://github.com/vuetifyjs/vuetify/issues/3436#issuecomment-371872303
const useHydrationFix = () => {
    const isHydrated = ref(false)

    onMounted((): void => {
        isHydrated.value = true
    })

    return {
        isHydrated
    }
}

export {
    useHydrationFix
}
